import { useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, Modal, Paper, Select, Stack, Typography } from '@mui/material';

const formControlStyle = { width: '90%', margin: 'auto', marginBottom: '16px' };

function DeleteHospital({hospital, hospitals, handleCloseModal, handleSaveChange}) {

  const [newHospitalName, setNewHospitalName] = useState('');

  const handleSave = () => {
    handleSaveChange({
      hospitalId: hospital.id,
      newHospitalName
    });
    handleCloseModal();
  };

  return (
    <Modal open={true} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Paper
        sx={{
          padding: '16px',
          position: 'absolute',
          minWidth: '550px',

          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography
          component="h3"
          sx={{
            fontSize: '1.5em',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          Delete Hospital: "{hospital.name}"
        </Typography>
        <Typography
          component="p"
          sx={{
            fontSize: '1em',
            textAlign: 'center',
            marginBottom: '8px',
          }}
        >
          Please select hospital to transfer users to.
        </Typography>
        <FormControl sx={formControlStyle} variant="standard">
        <InputLabel>Hospital</InputLabel>
        <Select value={newHospitalName} onChange={(event) => setNewHospitalName(event.target.value)}>
          {hospitals.map(({ name }) => (
            <MenuItem key={name} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack direction="row" justifyContent="flex-end">
        <Button onClick={handleCloseModal}>Cancel</Button>
        <Button variant="contained" onClick={handleSave} disabled={!newHospitalName || newHospitalName.length === 0}>
          Delete Hospital
        </Button>
      </Stack>
      </Paper>
    </Modal>
  )
}

export default DeleteHospital